import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-Roboto-Regular relative" }

import { ref, onMounted } from 'vue'
import Portfolio from './components/Portfolio.vue'
import Features from './components/Features.vue'
import Footer from './components/Footer.vue'
import Home from '@/components/Home.vue'
import NavBar from '@/components/Navbar.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const scrollTop = ref(0)
onMounted(() => {
  window.addEventListener('scroll', () => {
    scrollTop.value = document.documentElement.scrollTop
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavBar),
    _createVNode(Home),
    _createVNode(Features, { "scroll-top": scrollTop.value }, null, 8, ["scroll-top"]),
    _createVNode(Portfolio),
    _createVNode(Footer)
  ]))
}
}

})